var map = {
	"./feedback-status-ilustra.png": "c2c1",
	"./introduction-ilustra.png": "1c96",
	"./introduction-platform-ilustra.png": "a610",
	"./introduction-pos-system-ilustra.png": "a81d",
	"./refund-policy-ilustra.png": "f17e",
	"./reward-ratio-ilustra.png": "3750"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5117";